import styled from 'styled-components';

export const ServicesContainer = styled.div`
  width: 100%;
`;

export const ServicesHero = styled.section`
  background: linear-gradient(rgba(34, 139, 34, 0.8), rgba(34, 139, 34, 0.8)),
              url('/services-hero.jpg') center/cover;
  padding: 100px 0;
  color: white;
  text-align: center;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const PageTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const PageSubtitle = styled.p`
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;

export const ServicesContent = styled.section`
  padding: 80px 0;
  background: #f8f9fa;
`;

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  margin-bottom: 80px;
`;

export const ServiceCard = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  }
`;

export const ServiceImage = styled.div`
  height: 200px;
  background: linear-gradient(135deg, #228B22 0%, #32CD32 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 3rem;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ServiceContent = styled.div`
  padding: 30px;
`;

export const ServiceTitle = styled.h3`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
`;

export const ServiceDescription = styled.p`
  color: #666;
  line-height: 1.6;
  font-size: 1rem;
  margin-bottom: 20px;
`;

export const ServiceFeatures = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 20px;
  
  li {
    color: #555;
    margin-bottom: 8px;
    padding-left: 20px;
    position: relative;
    font-size: 0.95rem;
    
    &:before {
      content: '✓';
      position: absolute;
      left: 0;
      color: #228B22;
      font-weight: bold;
    }
  }
`;

export const ProcessSection = styled.section`
  padding: 80px 0;
  background: white;
`;

export const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 20px;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionSubtitle = styled.p`
  text-align: center;
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 60px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
`;

export const ProcessGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
`;

export const ProcessStep = styled.div`
  text-align: center;
  position: relative;
  
  &:not(:last-child):after {
    content: '→';
    position: absolute;
    top: 50px;
    right: -20px;
    font-size: 2rem;
    color: #8B4513;
    
    @media (max-width: 968px) {
      display: none;
    }
  }
`;

export const StepNumber = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #228B22 0%, #32CD32 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
`;

export const StepTitle = styled.h3`
  font-size: 1.3rem;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
`;

export const StepDescription = styled.p`
  color: #666;
  line-height: 1.6;
  font-size: 0.95rem;
`;

export const CTASection = styled.section`
  background: linear-gradient(135deg, #228B22 0%, #32CD32 100%);
  color: white;
  padding: 80px 0;
  text-align: center;
`;

export const CTATitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const CTAText = styled.p`
  font-size: 1.2rem;
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
`;

export const CTAButton = styled.button`
  background: white;
  color: #228B22;
  border: none;
  padding: 15px 30px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(255, 255, 255, 0.3);
  }
`;
